export const  checkColumns = [
  {
    title: '#',
    dataIndex: 'id',
    key: 'id',
    width: 60,
    customRender: (text, record, index) => {
      return index + 1
    },
  },
  {
    title: '商品图片',
    dataIndex: 'productImg',
    key: 'productImg',
    width: 120,
    scopedSlots: {
      customRender: 'productImgActive'
    }
  },
  {
    title: '商品规格',
    dataIndex: 'productProp',
    key: 'productProp',
    ellipsis: false,
  },
  {
    title: '商品SKU',
    dataIndex: 'productSku',
    key: 'productSku',
    ellipsis: false,
    scopedSlots: {
      customRender: 'productSku'
    }
  },
  {
    title: '商品名称',
    dataIndex: 'productName',
    key: 'productName',
    ellipsis: true,
    scopedSlots: {
      customRender: 'productName'
    }
  },
  {
    title: '特殊入库要求',
    dataIndex: 'spcialStockList',
    key: 'spcialStockList',
    scopedSlots: {
      customRender: 'spcialStockList'
    }
  },
  {
    title: '特殊质检要求',
    dataIndex: 'spcialCheckList',
    key: 'spcialCheckList',
    scopedSlots: {
      customRender: 'specialCheck'
    }
  },
  {
    title: '商品来源',
    dataIndex: 'directSaleFlag',
    key: 'directSaleFlag',
    width: 100,
    scopedSlots: {
      customRender: 'directSaleFlag'
    }
    // customRender: (text)=>{
    //   return text ? '直营' : '代采'
    // }
  },
  {
    title: '实际采购数量',
    dataIndex: 'purchaseNum',
    key: 'purchaseNum',
    width: 120,
    ellipsis: true,
  },
  {
    title: '已入库数量',
    dataIndex: 'stockInNum',
    key: 'stockInNum',
    width: 120,
    ellipsis: true,
  },
  {
    title: '抽检数量',
    dataIndex: 'spotCheckNum',
    key: 'spotCheckNum',
    width: 120,
    ellipsis: true,
  },
  {
    title: '异常数量',
    dataIndex: 'confirmNum',
    key: 'confirmNum',
    width: 120,
    ellipsis: true,
  },
  {
    title: '本次检查数量',
    key: 'checkAction',
    dataIndex: 'stockInNum',
    fixed:'right',
    width: 300,
    scopedSlots: {
      customRender: 'checkAction'
    }
  }
]
export const checkOperateColumns = [
  {
    title: '#',
    dataIndex: 'id',
    key: 'id',
    width: 40,
    customRender: (text, record, index) => {
      return index + 1
    },
  },
  {
    title: '批次号编号',
    dataIndex: 'pkgCode',
    key: 'pkgCode',
    ellipsis: true,
    scopedSlots: {
      customRender: 'pkgCode'
    }
  },
  {
    title: '包类型',
    dataIndex: 'pkgType',
    key: 'pkgType',
    ellipsis: true,
    customRender: (text, record, index) => {
      return record.isShortage ? '次品-少件到货' : {1:'正品',2:'次品',3:'异常',4:'异常上报采购',10:'自有'}[text]
    },
    width: 150
  },
  {
    title: '商品SKU',
    dataIndex: 'shopProductSku',
    key: 'shopProductSku',
    ellipsis: true,
    customRender: (text, record, index) => {
      return text || '-'
    },
  },
  // {
  //   title: '商品图片',
  //   dataIndex: 'productImg',
  //   key: 'productImg',
  //   scopedSlots: {
  //     customRender: 'productImgActive'
  //   }
  // },
  {
    title: '入库数量',
    dataIndex: 'originAmount',
    key: 'originAmount',
    ellipsis: true,
    width: 120
  },
  {
    title: '运单号',
    dataIndex: 'expressNo',
    key: 'expressNo',
  },
  {
    title: '入库时间',
    dataIndex: 'createTime',
    key: 'createTime',
    ellipsis: true,
  },
  {
    title: '操作',
    key: 'printAction',
    dataIndex: 'amount',
    width: 350,
    fixed: 'right',
    scopedSlots: {
      customRender: 'printAction'
    }
  }
]
const printTypes = ['未打印', '已打印']
const pkgStatusArr = ['正常包', '异常包']
